/* eslint-disable unicorn/prefer-blob-reading-methods,unicorn/consistent-destructuring */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols

import angular from 'angular';
import $ from 'jquery';
import * as jsonLogic from 'json-logic-js/logic';
import _ from 'lodash-es';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import APIV5 from '~/models/api';
import Defaults from '~/scripts/constants/defaults';
import { Confirm } from '~/scripts/services/modal/modal';
import FileUpload from '~/scripts/services/model/file-upload';
import { ConfirmDeleteModal } from '~/utils/modals';
import Droit from '~/scripts/services/model/droit';
import DroitDef from '~/scripts/services/model/droit-def';
import DroitCust from '~/scripts/services/model/droit-cust';
// eslint-disable-next-line import/no-cycle
import kformUtils from './utils/kform-utils';
import ModalUploadingController from '../upload/modal/modal-uploading.controller';
import templateModalUploadClassic from '../upload/modal/modal-uploading.html';
import Attribut from '~/scripts/services/model/attribut';
import Repre from '~/scripts/services/model/repre';

/* globals Knitiv */

/**
 * @typedef KformOptions
 * @property {boolean} displayBreadcrumb
 * @property {boolean} displayKelse
 * @property {boolean} displayTabs
 * @property {false | import('angular').bootstrap.ui.IModalInstanceService} modal
 * @property {'normal' | 'component_of'} mode
 * @property {string | undefined} name
 * @property {any} newFile
 * @property {any} parent
 * @property {boolean} preview
 * @property {boolean} readOnly
 * @property {boolean} tree
 * @property {string} tab
 * @property {number} viewMode
 */

/** ** old controller */
export const dataChanged = [];

export const checkJsonConditional = (component, json, row, data, form, onError) => {
	try {
		return jsonLogic.apply(json, {
			data,
			row,
			form,
			_,
		});
	}
	catch (error) {
		console.warn(`An error occurred in jsonLogic advanced condition for ${component.key}`, error);
		return onError;
	}
};

export default class KformController {
	#$injector;

	#$location;

	#$q;

	#$rootScope;

	#$sce;

	#$scope;

	#$translate;

	#$uibModal;

	#Agent;

	#Bookmark;

	#FileDownloadService;

	#FormService;

	#NodeService;

	#Notification;

	#User;

	#areas;

	#formParent;

	#newKid;

	#oldListWidth;

	#pristine;

	#rootFormKid;

	#temporaryFiles;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').location.ILocationService} $location
	 * @param {import('angular').IQService} $q
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} Agent
	 * @param {import('~/components/bookmark/bookmark.model').default} Bookmark
	 * @param {import('~/components/download/download.service').FileDownloadServiceModel} FileDownloadService
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {import('~/scripts/services/node.service').default} NodeService
	 * @param {any} Notification
	 * @param {any} User
	 */
	constructor(
		$injector,
		$location,
		$q,
		$rootScope,
		$sce,
		/** @type {Knitiv.Scope} */
		$scope,
		$timeout,
		$translate,
		$uibModal,
		Agent,
		Bookmark,
		FileDownloadService,
		FormService,
		NodeService,
		Notification,
		User,
	) {
		this.btnSubmitDisabled = false;
		this.create = undefined;
		this.comment = undefined;
		this.connectedAgent = undefined;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.currentKid = null;
		this.dev = process.env.NODE_ENV !== 'production';

		/** @type {KformOptions} */
		this.defaultOptions = {
			displayBreadcrumb: true,
			displayKelse:      true,
			displayTabs:       true,
			modal:             false,
			mode:              'normal',
			name:              undefined,
			newFile:           undefined,
			parent:            null,
			preview:           false,
			readOnly:          true,
			tree:              false,
			tab:               'form',
			viewMode:          1,
		};

		/** @type {boolean} */
		this.error = false;

		this.formId = undefined;

		/**
		 * @type {Record<
		 *   import('@knitiv/api-client-javascript').KNode,
		 *   import('~/scripts/services/model/form').default
		 * >}
		 */
		this.forms = {};

		this.from = undefined;

		/** @type {string} */
		this.fullScreenMode = undefined;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		this.histo = {
			data:    undefined,
			loading: false,
		};

		/** @type {boolean} */
		this.loading = false;

		this.loadGraph = undefined;

		/** @type {string} */
		this.name = undefined;

		/** @type {?Function} */
		this.onCancel = null;

		/** @type {?Function} */
		this.onBeforeSubmit = null;

		/** @type {?Function} */
		this.onSubmit = null;

		/** @type {KformOptions} */
		this.options = {};

		/** @type {import('tabulator-tables').RowComponent} */
		this.row = undefined;

		this.tab = undefined;

		/** @type {Set<import('@knitiv/api-client-javascript').KNode>} */
		this.targets = new Set();

		this.user = undefined;

		this.#areas = [
			'file',
			'details',
			'wf',
		];
		this.#formParent = undefined;
		this.#newKid = undefined;
		this.#pristine = true;
		this.#oldListWidth = {};
		this.#rootFormKid = undefined;
		this.#temporaryFiles = [];

		this.#$injector = $injector;
		this.#$location = $location;
		this.#$q = $q;
		this.#$rootScope = $rootScope;
		this.#$sce = $sce;
		this.#$scope = $scope;
		this.$timeout = $timeout;
		this.#$translate = $translate;
		this.#$uibModal = $uibModal;
		this.#Agent = Agent;
		this.#Bookmark = Bookmark;
		this.#FileDownloadService = FileDownloadService;
		this.#FormService = FormService;
		this.#NodeService = NodeService;
		this.#Notification = Notification;
		this.#User = User;
		this.Defaults = Defaults;
	}

	/**
	 * Adds a form or a subform
	 *
	 * @param {any} formClass class details
	 * @param {{
	 *   create?: boolean
	 *   field?: import('@knitiv/api-client-javascript').KNode
	 *   isa?: {
	 *     objid: import('@knitiv/api-client-javascript').KNode
	 *   }
	 *   k?: number
	 *   kid: import('@knitiv/api-client-javascript').KNode
	 *   linker_kid?: import('@knitiv/api-client-javascript').LinkerKNode
	 *   readOnly?: boolean
	 *   tab?: string
	 * }} parent parent details
	 * @param {{
	 *   current_kid?: import('@knitiv/api-client-javascript').KNode
	 *   items?: any[]
	 *   new_isa?: import('@knitiv/api-client-javascript').KNode
	 * }} options form options
	 * @returns {Promise<any>} Promise result
	 */
	async addForm(formClass, parent, options = {}) {
		const create = !('kid' in formClass);
		const kid = 'kid' in formClass ? formClass.kid : formClass.isa;

		if (this.options?.parent) {
			// eslint-disable-next-line no-param-reassign
			({ parent } = this.options);
		}

		if (parent && !options.noShow) {
			this.loading = true;
			this.forms[this.currentKid].formScope.kformForm.$setDirty();
		}

		// eslint-disable-next-line no-param-reassign
		options = {
			...options,
			create,
			rg: true,
		}

		if (parent) {
			options.parent = {
				isa: parent.isa,
				kid: parent.kid,
				name: parent.name,
				target: parent.target,
			};
			if (options.items && options.items.length > 0) {
				options.submission = options.items[0].submission;
			}
			delete options.items;
			delete options.method_kid;
		}

		try {
			const result = await this.#FormService.load(kid, options);
			this.error = false;
			if (create && this.#newKid && !parent) {
				formClass.kid = this.#newKid;
			}
			const form = await this.loadForm(result, parent, formClass, create, false, options);
			if (create) {
				form.readOnly = false;
				if (form.parent && form.hasParentRelation.fromParent && this.forms[form.parent.kid].readOnly === false) {
					form.target = form.parent.kid;
				}
				else {
					this.targets.add(this.currentKid);
					form.target = this.currentKid;
				}
			}
			if (create && !parent && this.#newKid) {
				formClass.kid = this.#newKid;
			}
			if (formClass.file) {
				await form.addFile(formClass.file);
			}
			else if (formClass.files) {
				await form.addFiles(formClass.files);
			}
			this.loading = false;
		}
		catch (error) {
			console.error(error);
			// this.error = true;
			this.loading = false;
		}
	}

	/**
	 * Adds a link to an existing node (from ktable)
	 *
	 * @param {Object} path path with values details
	 * @param {Object} parent parent details
	 * @param {string} key component key of the ktable
	 * @param {string} type value type
	 */
	addLinkTo(path, parent, key, type) {
		this.#$scope.$broadcast(`ktable-refresh-${this.currentKid}-${key}`);
		this.forms[this.currentKid].linkTo.push({ key, path, type });
	}

	/**
	 * Stores temp files from MF (for use later with loadForm method)
	 *
	 * @param {Array} files Files submitted from MF
	 */
	addTmpFiles(files) {
		this.#temporaryFiles.push(...files);
	}

	/**
	 * Restore list pane
	 */
	back() {
		this.#$scope.$emit('List.toggle-list', 'full');
	}

	/**
	 * Adds a bookmark
	 */
	bookmarkAdd() {
		this.#Bookmark.add(this.forms[this.kid].name, {
			data: {
				kid: this.forms[this.kid].kid,
			},
			type: 'node',
		});
	}

	/**
	 * Calls history
	 */
	async callHisto() {
		this.histo.data = undefined;
		if (this.forms[this.currentKid].params.displayTabHisto === true) {
			this.histo.loading = true;
			try {
				this.histo.data = await APIV5.instance.objectHisto(
					this.forms[this.currentKid].kid,
					{ id: 'kform-tab-histo.load' },
				);
				this.histo.loading = false;
			}
			catch (error) {
				this.histo.loading = false;
				console.error(error);
			}
			this.$timeout(() => {
				this.#$scope.$apply();
			});
		}
	}

	/**
	 * Call graph
	 */
	callGraph() {
		this.loadGraph = true;
	}

	/**
	 * Cancel
	 *
	 * @param {boolean} force Cancel the form without confirmation
	 * @param {Event} event Event object
	 * @returns {Promise<boolean>} sucessful return
	 */
	async cancel(force, event) {
		const oldFormKid = this.currentKid;
		if (
			!force
			&& this.forms[this.currentKid].parent?.kid in this.forms
		) {
			const parentKid = this.forms[this.currentKid].parent.kid;

			await this.forms[this.currentKid].reset();

			if (parentKid in this.forms) {
				this.currentKid = parentKid;
				this.selectedForm = this.forms[parentKid].branch;
				this.setName();
				if (this.forms[this.currentKid].script) {
					this.forms[this.currentKid].kexecScriptWrapper({
						origin: 'kform',
						method: 'cancel',
					});
				}
			}
		}
		else {
			if (this.#formParent && this.#$scope.$parent.forms && this.currentKid in this.#$scope.$parent.forms) {
				delete this.#$scope.$parent.forms[this.currentKid];
			}

			if (
				this.#pristine
				&& this.forms[this.currentKid].formWF?.$pristine
				&& this.forms[this.currentKid].formRights?.$pristine
			) {
				this.#$scope.$emit('Form.cancel');
				await this.forms[this.currentKid].reset();
				if (typeof this.onCancel === 'function') {
					this.onCancel();
				}
			}
			else {
				const modal = new Confirm(this.#$injector);
				const answer = await modal.open({
					title:  this.#$translate.instant('object.confirm-delete-title'),
					body:   `<p><b>${this.#$translate.instant('form.confirm-cancel-title')}</b></p>
<p>${this.#$translate.instant('form.confirm-cancel-message')}</p>`,
					accept: {
						label: this.#$translate.instant('common.ok'),
						type:  'primary',
					},
					cancel: {
						label: this.#$translate.instant('common.cancel'),
						type:  'warning',
					},
				});

				// eslint-disable-next-line consistent-return
				this.#$scope.$evalAsync(() => {
					if (answer) {
						if (typeof this.onCancel === 'function') {
							this.#$scope.$emit('Form.cancel');
							this.forms[this.currentKid].reset();
							if (typeof this.onCancel === 'function') {
								this.onCancel();
							}
						}
						this.#$rootScope.showSearch = true;
						return true;
					}
					if (event) {
						event.preventDefault();
					}
				});
			}
		}

		this.targets.delete(oldFormKid)

		return false;
	}

	/**
	 *
	 * @param {string} key
	 * @param {any[]} oldData
	 */
	changeValue(key, oldData) {
		this.forms[this.currentKid].submission.data[key] = this.forms[this.currentKid].submission.data[key]
			.map((/** @type {any} */ d) => {
				// search for existing value
				const item = oldData.find((/** @type {{ name: any; }} */ v) => v.name === d.name);
				d.kid = item && d?.name ? item.kid : undefined;
				return d;
			});
	}

	collaboraSave() {
		this.#$rootScope.$broadcast('collabora.save');
	}

	/**
	 * Copy link preview
	 */
	copyLinkPreview() {
		this.forms[this.currentKid].copyLinkPreview();
	}

	/**
	 * Deletes the node of the specified form
	 *
	 * @param {import('~/scripts/services/model/form').default} form Form instance
	 */
	async delete(form) {
		const modal = new ConfirmDeleteModal(this.#$injector);
		const answer = await modal.open(form.getName());

		if (answer) {
			await this.#FormService.delete(form.kid);
			if (this.row) {
				this.row.getTable()
					.deleteRow(form.kid);
			}
			this.#Notification.info({
				title:   this.#$translate.instant('object.successfully-deleted-title'),
				message: this.#$translate.instant('object.successfully-deleted-message'),
			});
		}
	}

	/**
	 * Edits the current form
	 *
	 * @returns {Promise<boolean>}
	 */
	async edit() {
		if (this.currentKid in this.forms) {
			const form = this.forms[this.currentKid];
			const editable = form.edit();
			if (editable) {
				if (form.parent && form.hasParentRelation.fromParent && this.forms[form.parent.kid].readOnly === false) {
					form.target = form.parent.kid;
				}
				else {
					this.targets.add(this.currentKid);
					form.target = this.currentKid;
				}
			}
			return editable;
		}

		await this.cancel(true, null);
		return true;
	}

	/**
	 * Generates the breadcrumb of the specified form
	 *
	 * @param {string} kid KID of the form
	 * @returns {Array} the generated breadcrumb
	 */
	getBreadCrumb(kid) {
		const breadcrumb = [];
		if (kid in this.forms) {
			breadcrumb.unshift(this.forms[kid]);
			let { parent } = this.forms[kid];
			while (parent) {
				breadcrumb.unshift(this.forms[parent.kid]);
				parent = parent.kid in this.forms ? this.forms[parent.kid].parent : null;
			}
		}

		return breadcrumb;
	}

	getBtnRecord() {
		const form = this.forms[this.currentKid];
		if (form.parent?.kid && form.parent.kid in this.forms && this.targets.has(this.forms[form.parent.kid].target)) {
			return this.Defaults.kform.btn_record.submit;
		}
		return this.Defaults.kform.btn_record.save;
	}

	// eslint-disable-next-line class-methods-use-this
	getName(form) {
		let name = form.isa.objname;
		if (form.name) {
			name += ` : ${form.name}`;
		}
		return name;
	}

	/**
	 * @returns {boolean}
	 */
	hasOfficeFiles() {
		let hasFiles = false;
		for (const form of Object.values(this.forms)) {
			if (form.viewer_engine === 'office') {
				hasFiles = true;
			}
		}
		return hasFiles;
	}

	isInteraction() {
		return this.forms[this.currentKid].isa.objid === 'K_NODE;cENTRETIEN';
	}

	isPerson() {
		return this.forms[this.currentKid].isa.objid === 'K_NODE;PERSON_OWNER';
	}

	isProject() {
		const projectsKid = [
			'K_NODE;PROJECT',
			'K_NODE;cPROJECTCIAL',
		];
		return projectsKid.includes(this.forms[this.currentKid].isa.objid);
	}

	/**
	 * Loads the form after calling FormService.load
	 *
	 * @param {import('~/scripts/services/model/form').default} form output of FormService.load
	 * @param {any} parent parent details
	 * @param {any} formClass class details
	 * @param {boolean} create create flag
	 * @param {boolean} refresh refresh flag
	 * @param {any} options don't show the form
	 * @returns {import('angular').IPromise} Promise result
	 */
	async loadForm(form, parent, formClass, create, refresh, options = {}) {
		if (!form) {
			return this.#$q.reject();
		}

		if (formClass.ktableController) {
			if (create) {
				formClass.ktableController.tempKid = form.kid;
			}
			this.options.ktableKey = formClass.ktableController.component?.key;
		}

		this.selectedForm = form.kid;
		form.parent = parent;

		if (this.row && !form.parent) {
			form.row = this.row;
		}

		if (parent && parent.kid in this.forms && !this.forms[parent.kid].nodes.some(form2 => form2.kid === form.kid)) {
			this.forms[parent.kid].nodes.push(form);
		}

		if (create && !parent) {
			const repreFromUrl = this.#$location.search().repre;
			if (!form.name && repreFromUrl) {
				form.setName(repreFromUrl);
			}
			else if (this.options.name) {
				form.setName(this.options.name);
			}
		}

		if (create || form.new_isa) {
			form.modified = true;
		}

		if (refresh && this.forms[form.kid]) {
			// Merge the form from refresh action
			_.merge(this.forms[form.kid], form);
		}
		else {
			this.forms[form.kid] = form;
		}
		// this.loadSubmission(form, submission)

		form.attribut = form.submission.kattribut.map(a => new Attribut(a));

		form.droit = form.submission.kdroit.map(d => new Droit(d));
		if (form.submission.kdroitcust) {
			form.droitcust.push(...form.submission.kdroitcust.map(d => new DroitCust(d)));
		}
		if (this.#$rootScope.context?.role.mode === 'ADMIN_SUPER' && form.submission.kdroitdef) {
			form.droitdef.push(...form.submission.kdroitdef.map(d => new DroitDef(d)));
		}

		let { defaultTab } = form.params;

		// set defaultTab = 'form' if defaultTab is 'file' and we are in preview mode
		if (this.options.preview && defaultTab === 'file') {
			defaultTab = 'form';
		}

		form.tab = this.tab || this.options.tab || defaultTab || 'form';

		// eslint-disable-next-line unicorn/prevent-abbreviations
		const def = await this.#NodeService.loadDef(form.isa.objid);
		if (def) {
			form.wf = def.wf;
		}

		if (!this.options?.modal) {
			this.#$location.search('tab', form.tab)
				.replace();
		}

		// eslint-disable-next-line unicorn/consistent-destructuring
		this.options.tree = form.params.tree;

		if (this.#temporaryFiles.length > 0) {
			for (const file of this.#temporaryFiles) {
				form.files.push(new FileUpload(this.#$injector, file.file, file.name));
			}
			this.#temporaryFiles.length = 0;
			form.isfile = true;
		}
		else if (!this.#$rootScope.kds && form.isfile) {
			const file = new FileUpload(this.#$injector, {
				size: form.getAttribute('F_SIZE')?.value,
				type: form.getAttribute('F_MIMETYPE')?.value,
				name: form.getAttribute('F_FILENAME')?.value,
			});

			file.uploaded = true;
			form.files = [file];

			// if (this.options.preview && form.tab === 'file') {
			// 	form.tab = 'form';
			// }
		}
		// else if (this.#$rootScope.kds && form.files.length > 0) {
		// 	form.files = form.files
		// 		? form.files.map(file => new FileUpload(this.#$injector, file, file.name.user))
		// 		: [];
		// }

		// if (form.tab === 'file' && this.forms[form.kid]) {
		// 	form.tab = form.params.defaultTab;
		// }

		// recherche du form parent dans le scope
		if (this.options.mode === 'component_of') {
			let scopeParent = this.#$scope.$parent;
			while (scopeParent && !('form' in scopeParent && scopeParent.form)) {
				scopeParent = scopeParent.$parent;
				this.#formParent = scopeParent.form;
			}

			if (scopeParent) {
				scopeParent = scopeParent.$parent;
			}

			// fusion des données forms + submission (à plat)
			if ('forms' in scopeParent) {
				_.merge(scopeParent.forms, this.forms);
			}

			// recherche dans la map en cours s'il y a un definedby sur le parent
			if (this.#formParent.create) {
				for (const [key, component] of Object.entries(form.map)) {
					if (this.#formParent && this.#formParent.isa.objid === component.kid) {
						form.submission.data[key] = [
							{
								kid:  this.#formParent.kid,
								name: this.#formParent.getName(),
							},
						];
					}
				}
			}
		}

		this.forms[form.kid].isTerminal = false;
		if (!options.noShow && (!parent || (parent && !form.lastForm))) {
			this.currentKid = form.kid;
		}
		else {
			this.currentKid = parent.kid;
			this.forms[form.kid].isTerminal = true;
		}

		if (formClass.name && !this.forms[form.kid].name) {
			this.forms[form.kid].name = formClass.name;
		}

		if (!this.forms[form.kid].isTerminal) {
			this.setName();
		}

		if (parent && parent.field && parent.kid in this.forms && this.#rootFormKid) {
			if (this.forms[parent.kid].submission.data[parent.field] === undefined) {
				this.forms[parent.kid].submission.data[parent.field] = [{ kid: form.kid }];
			}
			else {
				this.forms[parent.kid].submission.data[parent.field][parent.k || 0].kid = form.kid;
			}
			this.#FormService.mfCacheAdd(
				form.isa.objid,
				this.forms[parent.kid].submission.data[parent.field][parent.k || 0],
				parent.kid,
			);
		}

		// Probe for repre update from MF
		this.#$scope.$watch(() => (form.submission?.data?.KREPRE), (newRepre, oldRepre) => {
			if (
				newRepre && !_.isEqual(newRepre, oldRepre) && form.kid in this.forms
				&& form.kid in this.forms && this.forms[form.kid] && form.submission.data.KREPRE
			) {
				this.forms[form.kid].repre = form.submission.data.KREPRE.map(krepre => new Repre(krepre));
				this.forms[form.kid].name = this.forms[form.kid].getName(true);
				this.forms[form.kid].modified = true;
				// const sparent = this.forms[form.kid].parent;

				for (const [formKid, sform] of Object.entries(this.forms)) {
					for (const [sfield, map] of Object.entries(sform.map)) {
						if (
							map.type === 'mf'
							&& map.kid === this.forms[form.kid].isa.objid
							&& Array.isArray(this.forms[formKid].submission.data[sfield])
							&& this.forms[formKid].submission.data[sfield].length > 0
						) {
							for (const value of Object.values(this.forms[formKid].submission.data[sfield])) {
								if (value.kid === form.kid) {
									value.name = this.forms[form.kid].getName();
								}
							}
						}
					}
				}

				this.setName();
			}
		}, true);

		if (!this.#rootFormKid) {
			this.#rootFormKid = form.kid;
			await this.#FormService.reset();

			// Probe for pristine update
			this.#$scope.$watch(`$ctrl.forms["${this.#rootFormKid}"].formScope.kformForm.$pristine`, (p, oldp) => {
				if (p && !oldp && this.forms[this.#rootFormKid].modified) {
					// trick to avoid pristine form when coming from child form
					this.forms[this.#rootFormKid].formScope?.kformForm?.$setDirty();
				}
				else {
					this.#pristine = p;
				}
			});
		}

		if (form.components.length > 0) {
			const componentsChildren = {};

			for (const sform of Object.values(this.forms)) {
				for (const [k, map] of Object.entries(sform.map)) {
					if (map && 'path' in map) {
						for (const path of map.path) {
							if (!(path in componentsChildren)) {
								componentsChildren[path] = [];
							}
							if (!componentsChildren[path].includes(k)) {
								componentsChildren[path].push(k);
							}
						}
					}
				}
			}

			// il s'agit d'appeler les champ de manière recursive ... et de faire les watch en commençant par le plus bas
			// pour qu'ils soient tous pris en compte.

			// on prends tout les objets qui sont enfant

			// { K2000 null } { CERVEAU : down }

			// const buildDict = () => {
			// 	const returnValue = [];
			// 	for (const [key, map] of Object.entries(this.forms[form.kid].map)) {
			// 		if (typeof map === 'object' && 'path' in map && map.path.length > 0) {
			// 			returnValue.push({
			// 				key,
			// 				current: {
			// 					kid:        map.path.at(-1)?.kid,
			// 					linker_kid: map.path.at(-1)?.linker_kid,
			// 				},
			// 				parent:  {
			// 					kid:        map.path.at(-2)?.kid,
			// 					linker_kid: map.path.at(-2)?.linker_kid,
			// 				},
			// 			});
			// 		}
			// 	}
			// 	return returnValue;
			// };

			// let n = 0;
			// const buildTree = (sparent, dic, tree) => {
			// 	for (const dicElement of dic) {
			// 		if (dicElement.parent.kid === sparent.kid && dicElement.parent.linker_kid === sparent.linker_kid) {
			// 			const treeElement = {
			// 				kid:        dicElement.kid,
			// 				isa:        dicElement.current.kid,
			// 				linker_kid: dicElement.current.linker_kid,
			// 				children:   [],
			// 			};
			// 			tree.push(treeElement);
			//
			// 			if (dicElement.current.kid === form.isa.objid) {
			// 				n++;
			// 			}
			//
			// 			if (n < 10) {
			// 				buildTree(dicElement.current, dic, treeElement.children);
			// 			}
			// 		}
			// 	}
			// };

			const isElementOf = (children, isa) => {
				let returnValue = false;
				// eslint-disable-next-line max-len
				// eslint-disable-next-line unicorn/no-array-for-each,no-shadow,unicorn/no-array-method-this-argument,unicorn/no-array-callback-reference
				angular.forEach(children, element => {
					if (element.isa === isa) {
						returnValue = element.kid;
					}
				});
				return returnValue;
			};

			const tree = [];
			// buildTree(form.isa.objid, buildDict(), tree);

			const changeSubmission = k => {
				let returnValue = '';
				if (form.submission) {
					if (Array.isArray(form.submission.data[k]) && form.submission.data[k].length > 0) {
						// eslint-disable-next-line max-len
						// eslint-disable-next-line unicorn/no-array-for-each,unicorn/no-array-method-this-argument,unicorn/no-array-callback-reference
						angular.forEach(form.submission.data[k], element_ => {
							returnValue += `${element_.kid}`;
						});
					}
					else if (Array.isArray(form.submission.data[k])) {
						returnValue += 0;
					}
					else {
						returnValue += form.submission.data[k];
					}
				}
				return `'${returnValue}'`;
			};

			const resetChildren = (stree, exceptKey) => {
				// eslint-disable-next-line max-len
				// eslint-disable-next-line unicorn/no-array-method-this-argument,unicorn/no-array-for-each,unicorn/no-array-callback-reference
				angular.forEach(stree, t => {
					if (t.kid !== exceptKey) {
						form.submission.data[t.kid] = form.flatTypes[t.kid] === 'mf' ? [] : undefined;
						resetChildren(t.children);
					}
				});
			};

			const setChildren = (k, children, newValue, index) => {
				// TODO rustine en attendant un couche de cache.
				if (!newValue[index].kid.startsWith('K_NODE;_NR_')) {
					return APIV5.instance.objectInfo(
						{ kid: newValue[index].kid },
						{ id: 'kform.load-form.set-children' },
					)
						.then(sresult => {
							if (COMPOSED_OF in sresult.link.list.from) {
								for (const link of Object.values(sresult.link.list.from[COMPOSED_OF].list)) {
									const childKid = isElementOf(children, link.isa);
									if (childKid && typeof childKid === 'string') {
										if (form.flatTypes[childKid] === 'mf') {
											if (
												!(childKid in form.submission.data)
												|| form.submission.data[childKid] === undefined
											) {
												form.submission.data[childKid] = [];
											}
											form.submission.data[childKid].push({
												kid:  link.objnum2_kid,
												name: link.objname,
											});
										}
										else if (form.flatTypes[childKid] === 'smartfield') {
											form.submission.data[childKid] = {
												kid:  link.objnum2_kid,
												name: link.objname,
											};
										}
										else {
											form.submission.data[childKid] = link.objname;
										}
									}
								}
							}
							return this.$timeout(() => {
								this.#$scope.$apply();
							});
						})
						.catch(console.error);
				}
				return this.#$q.reject();
			};

			const watch = (key, children) => {
				this.#$scope.$watch(() => changeSubmission(key), () => {
					if (form.submission) {
						const newValue = form.submission.data[key];
						if (Array.isArray(newValue) && newValue[0] && 'kid' in newValue[0]) {
							resetChildren(children, key);
							setChildren(key, children, newValue, 0);
						}
					}
				});
			};

			const parseTree = t => {
				for (const te of t) {
					parseTree(te.children);
					watch(te.kid, te.children);
				}
			};

			parseTree(tree);
		}

		// if (this.options.editMode === 'edit') {
		// 	await this.edit();
		// }

		return this.$timeout(() => {
			// TODO check use
			// if (!branch.lastForm) {
			//	this.selectedForm = branch;
			// }
			if (this.options.newFile) {
				form.addFile(this.options.newFile);
			}

			this.$timeout(() => {
				if (this.forms[form.kid]?.formScope?.kformForm) {
					if (refresh) {
						this.forms[form.kid].formScope.kformForm.$commitViewValue();
					}
					if (this.forms[form.kid].parent) {
						this.forms[form.kid].formScope.kformForm.$setDirty();
					}
					else {
						if (!refresh) {
							this.forms[form.kid].modified = false;
						}
						this.forms[form.kid].formScope.kformForm.$setPristine();
						this.forms[form.kid].formScope.kformForm.$setUntouched();
					}
				}
				if (refresh) {
					// force JS conditional reexec after refresh
					this.forms[form.kid].cacheKeys = {};

					// set dirty form after refresh
					if (this.forms[form.kid].formScope?.kformForm) {
						this.forms[form.kid].formScope.kformForm.$setDirty();
					}
				}

				if (this.forms[form.kid]?.script) {
					// this.$timeout(() => {
					this.forms[form.kid].kexecScriptWrapper({
						origin: 'kform',
						method: 'loadForm',
					}); // jshint ignore:line
					// }, 500);
				}
				else {
					this.loading = false;
				}

				this.#$scope.$apply();
			});

			this.#$scope.$apply();
			return this.forms[form.kid];
		}, 100);
	}

	/**
	 * @param {import('~/scripts/services/model/form').default} form
	 * @param {any} submission
	 */
	loadSubmission(form, submission) {
		form.submission.data = {
			...form.submission.data,
			...submission?.data,
		};
		form.submission.params = submission.params ?? {};

		if ('KREPRE' in form.submission.data) {
			form.submission.data.KREPRE = form.submission.data.KREPRE.map(
				(/** @type {any} */ repre) => new Repre(repre),
			);
		}

		form.submission.kattribut = submission.kattribut ?? [];
		form.submission.kdroit = submission.kdroit ?? [];
		form.submission.kdroitcust = submission.kdroitcust ?? [];
		form.submission.kdroitdef = submission.kdroitdef ?? [];
		form.submission.krepre = submission.krepre?.map(
			(/** @type {any} */ repre) => new Repre(repre),
		) ?? [];
		form.submission.wf = submission.wf ?? [];
	}

	openAktivNote() {
		window.open(`/front5/aktivnote/note?interaction=${this.kid}`);
	}

	/**
	 * Opens the specified form
	 *
	 * @param {string} formKid KID of the form
	 * @param {{
	 *   create?: boolean,
	 *   field?: import('@knitiv/api-client-javascript').KNode,
	 *   isa?: {
	 *     objid: import('@knitiv/api-client-javascript').KNode
	 *   },
	 *   k?: number,
	 *   kid: import('@knitiv/api-client-javascript').KNode,
	 *   linker_kid?: import('@knitiv/api-client-javascript').LinkerKNode,
	 *   tab?: string,
	 * }} parent parent details
	 * @param {string} tab tab to open
	 */
	async openForm(formKid, parent, tab = 'form') {
		if (!(formKid in this.forms)) {
			await this.addForm({ kid: formKid }, parent);
		}

		if (formKid in this.forms) {
			this.currentKid = formKid;
			this.selectedForm = this.forms[formKid].branch;
			this.setName();
			if (parent) {
				this.forms[formKid].fixKtableOptionParentCreate(parent.create);
			}
			await this.$timeout(() => {
				if (this.forms[formKid].script) {
					this.forms[formKid].kexecScriptWrapper({
						origin: 'kform',
						method: 'openForm',
					});
				}
				this.forms[this.currentKid].tab = tab;
			});
		}
	}

	openPersonMatrix() {
		window.open(`/front5/aktivnote/matrix?people=${this.kid}`);
	}

	openProjectMatrix() {
		window.open(`/front5/aktivnote/matrix?project=${this.kid}`);
	}

	/**
	 * Redirects to the parent form of current form
	 */
	parent() {
		if (this.forms[this.currentKid]?.parent?.kid in this.forms) {
			const parentKid = this.forms[this.currentKid].parent.kid;
			if (parentKid) {
				this.currentKid = parentKid;
				this.selectedForm = this.forms[parentKid].branch;
				this.setName();
			}
		}
	}

	recursiveDeleteForm(kid) {
		if (this.forms && kid in this.forms) {
			this.forms[kid].nodes.map(form => this.recursiveDeleteForm(form.kid));
			delete this.forms[kid];
		}
	}

	/**
	 * Refreshes the current form
	 */
	async refreshForm() {
		const form = this.forms[this.currentKid];
		const formKid = form.kid;
		const isDirty = form.formScope.kformForm.$dirty;

		this.loading = true;

		if (form.components) {
			form.components.length = 0;
		}
		else {
			form.components = [];
		}

		try {
			const result = await this.#FormService.refresh(
				form.create ? form.isa.objid : form.kid,
				{
					create:      form.create,
					current_kid: form.kid,
					detail:      'OBJECTINFO',
					rg:          true,
					parent:      form.parent,
					target:      form.target,
				},
				form.readOnly ? [] : this.forms,
			);
			this.loadForm(result, form.parent, {
				kid:  formKid,
				name: form.name,
			}, form.create, true);
			this.$timeout(() => {
				if (!isDirty) {
					this.forms[formKid].modified = false;
					this.forms[formKid].formScope.kformForm.$setPristine();
					this.forms[formKid].formScope.kformForm.$setUntouched();
				}
			}, 500);
		}
		catch (error) {
			this.loading = false;
			console.error(error);
		}
	}

	renderFileAsHTML(text) {
		this.$timeout(() => {
			const toParse = /<body>([\S\s]*)<\/body>/.exec(text);
			const elementView = angular.element('#html-view');
			elementView.empty();
			if (toParse?.length === 2) {
				const $compile = this.#$injector.get('$compile');
				// @ts-ignore
				const compiled = $compile($(`<div>${toParse[1]}</div>`))(_.extend(this.#$rootScope.$new(true), {
					$ctrl: {},
				}));
				elementView.append(compiled[0]);
			}
			else {
				elementView.append(text);
			}
		});
	}

	/**
	 * @param {Event} event
	 */
	log(event) {
		event.preventDefault();
		// eslint-disable-next-line no-console
		console.log(this);
	}

	/**
	 * @param {Event} event
	 */
	async logKformSetOrder(event) {
		event.preventDefault();

		const items = [];
		for (const target of this.targets) {
			const item = await this.#FormService.getItemForSave(this.forms, target);
			if (item) {
				items.push(item);
			}
		}
		// eslint-disable-next-line no-console
		console.log(JSON.parse(angular.toJson({ items })));
	}

	selectViewMode(viewMode) {
		this.options.viewMode = viewMode;

		switch (this.forms[this.currentKid].tab) {
		case 'file': {
			if (viewMode === 2) {
				this.forms[this.currentKid].tab = 'form';
			}
			break;
		}

		case 'details': {
			if (viewMode === 3) {
				this.forms[this.currentKid].tab = 'wf';
			}
			break;
		}

		default: {
			this.forms[this.currentKid].tab = 'form';
		}
		}

		if (!this.options.modal) {
			this.#$location.search({
				mode: viewMode,
				tab:  this.forms[this.currentKid].tab,
			})
				.replace();
		}
	}

	setName() {
		this.name = this.getName(this.forms[this.currentKid]);
		this.#$rootScope.title = this.name + (this.create ? ` (${this.#$translate.instant('common.creation')})` : '');
	}

	/**
	 * Submits the current form
	 *
	 * @param {'submit' | 'save' | undefined} action action of the submit button
	 */
	async submit(action) {
		// TEMP TEST
		if (!action) {
			// eslint-disable-next-line no-param-reassign
			action = this.forms[this.currentKid].parent && this.forms[this.currentKid].parent.kid in this.forms
				? 'submit' : 'save';
		}

		// if the current form has a parent, return to it
		if (action === 'submit') {
			const form = this.forms[this.currentKid];
			const { parent } = form;

			if (!form.kndef?.NAME_ONFLY?.OBJECT) {
				const classNode = await this.#NodeService.load(form.isa.objid);
				form.kndef = classNode.kndef;
			}

			const { kndef } = form;
			const nameOnFly = kndef.NAME_ONFLY?.OBJECT?.USE ?? null;
			const formChildIsDirty = form.formScope.kformForm.$dirty;

			this.currentKid = form.parent.kid;
			this.$timeout(() => {
				if (formChildIsDirty && this.forms[this.selectedForm]) {
					this.forms[this.selectedForm].formScope.kformForm.$setDirty();
					form.modified = true;
				}
				if (nameOnFly) {
					const updateName = () => nameOnFly.replaceAll(/\[([\w;]+)(?:#([\w;]+))?]/g, (m, kid, linkerKid = '0') => {
						// search in map
						const key = Object.keys(this.forms[this.selectedForm].map)
							.find(k => this.forms[this.selectedForm].map[k].path.at(-1).kid === kid
								&& this.forms[this.selectedForm].map[k].path.at(-1).linker_kid === linkerKid);

						let value = key && key in this.forms[this.selectedForm].submission.data
							? this.forms[this.selectedForm].submission.data[key] : '';

						if (Array.isArray(value) && value.length > 0) {
							value = value[0].name;
						}
						else if (typeof value === 'object' && 'name' in value) {
							value = value.name;
						}

						return typeof value === 'string' ? value.replaceAll(/\s{2,}/g, ' ')
							.trim() : '';
					});

					// recherche du MF dans le form parent
					for (const [k, v] of Object.entries(this.forms[parent.kid].submission.data)) {
						if (k === parent.field) {
							if (Array.isArray(v) && v.length > 0) {
								this.forms[parent.kid].submission.data[k][parent.k].name = updateName();
							}
							else if (typeof v === 'object' && 'name' in v) {
								this.forms[parent.kid].submission.data[k].name = updateName();
							}
							else if (typeof v === 'string') {
								this.forms[parent.kid].submission.data[k] = updateName();
							}
						}
					}
				}

				this.selectedForm = parent.kid;
				this.setName();
				if (form.script) {
					form.kexecScriptWrapper({
						origin: 'kform',
						method: 'submit',
					});
				}
				this.$timeout(() => {
					if (form.modified) {
						form.formScope.kformForm?.$setDirty();
					}
				});
			});
		}
		else if (action === 'save') {
			const { target } = this.forms[this.currentKid];
			let saveForms = true;
			if (typeof this.onBeforeSubmit === 'function') {
				await this.onBeforeSubmit({
					forms: this.forms,
				});
			}

			if (this.options.mode === 'component_of' && typeof this.onSubmit === 'function') {
				this.onSubmit({
					forms: this.forms,
				});
				saveForms = !this.#formParent.create;
			}

			if (saveForms) {
				this.loading = true;
				const filesToUpload = [];

				for (const form of Object.values(this.forms)) {
					if (form.files.length > 0 && form.target === target) {
						filesToUpload.push(...form.files.filter(f => f.file && !f.uploaded && !f.deleted));
					}
				}

				if (filesToUpload.length > 0) {
					const modalInstance = this.#$uibModal.open({
						ariaLabelledBy:  'modal-uploading-title',
						ariaDescribedBy: 'modal-uploading-body',
						backdrop:        false,
						controller:      ModalUploadingController,
						controllerAs:    '$ctrl',
						template:        templateModalUploadClassic,
						size:            'sm',
						resolve:         {
							files: () => filesToUpload,
						},
						windowClass:     'modal-upload',
					});
					const modalUpload = await modalInstance.opened;

					if (modalUpload) {
						await this.submitForms(target);
						this.$timeout(() => {
							modalInstance.close();
						}, 3000);
					}
				}
				else {
					await this.submitForms(target);
				}
			}
		}
		else {
			console.error('Unknown action:', action);
		}
	}

	/**
	 * Submit all forms
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} target
	 * @returns {import('angular').IPromise} Promise result
	 */
	async submitForms(target) {
		try {
			await Object.keys(this.forms)
				.filter(kid => this.forms[kid].target === target)
				.map(kid => {
					this.forms[kid].kid = kid;
					return this.forms[kid].upload.bind(this.forms[kid]);
				})

				// Uploads updated or new files from file tab
				// eslint-disable-next-line unicorn/no-array-reduce
				.reduce(async (promise, asyncFunction) => {
					const resultUpload = await promise;
					if (resultUpload && this.row) {
						await this.row.update({
							file: 1,
						});
					}
					return asyncFunction();
				}, Promise.resolve());

			// Gets files from MF fields inside the form
			await this.#FormService.getFilesFromMF(this.forms);

			// Calls the API to save the entire form (KFormSet)
			const result = await this.#FormService.save(this.forms, this.targets);

			// After successful saving, runs the following code
			const itemName = this.currentKid && this.currentKid in this.forms
				&& this.forms[this.currentKid].getName();

			if (result) {
				// Merge returned data to existing form and submission
				for (const k of Object.keys(this.forms)) {
					if (k in result.forms) {
						// this.forms[k].readOnly = true;
						if (!this.forms[k].create) {
							delete result.forms[k].components[1]?.options?.parent;
						}
						const parent = { ...this.forms[k].parent };
						// this.forms[k] = new Form(result.forms[k]);
						// _.merge(this.forms[k], result.forms[k]);

						// this.forms[k] = new Form(this.#$injector, {
						// 	...result.forms[k],
						// 	formAttribut: this.forms[k].formAttribut,
						// 	formRepre:    this.forms[k].formRepre,
						// 	formRights:   this.forms[k].formRights,
						// 	formScope:    this.forms[k].formScope,
						// 	formWF:       this.forms[k].formWF,
						// 	readOnly:     true,
						// 	submission:   result.submission[k],
						// });

						this.loadSubmission(this.forms[k], result.submission[k]);
						this.forms[k].modified = false;
						this.forms[k].parent = parent;

						this.$timeout(() => {
							if (this.forms[k].formScope?.kformForm) {
								this.forms[k].formScope.kformForm.$setUntouched();
								this.forms[k].formScope.kformForm.$setPristine();
							}
						}, 150);
					}
				}

				// Relauch queries in all ktable components
				this.#$scope.$broadcast('ktable-refresh');

				this.$timeout(async () => {
					this.#$scope.$apply();

					// Reexecutes the script
					if (this.currentKid in this.forms && this.forms && this.forms[this.currentKid].script) {
						this.forms[this.currentKid].kexecScriptWrapper({
							origin: 'kform',
							method: 'submitForms',
						});
					}

					this.loading = false;
				});

				const itemKid = Object.keys(result.forms)[0];

				// Set "create" flag to false and reset WF editor
				for (const form of Object.values(this.forms)) {
					form.create = false;
					form.workflow.length = 0;
				}

				if (this.create) {
					this.#Notification.success({
						title:   this.#$translate.instant('object.successfully-created-title'),
						message: this.#$translate.instant('object.successfully-created-message'),
					});
				}
				else {
					this.#Notification.success({
						title:   this.#$translate.instant('object.successfully-updated-title'),
						message: this.#$translate.instant('object.successfully-updated-message'),
					});
				}

				if (this.forms[this.currentKid]?.parent?.kid in this.forms) {
					await this.submit('submit');
				}
				else if (typeof this.onSubmit === 'function') {
					this.onSubmit({
						itemKid,
						itemName,
					});
				}
				if (this.currentKid && this.currentKid in this.forms) {
					this.forms[this.currentKid].readOnly = true;
				}
			}
			else {
				this.loading = false;
			}

			// Déverouillage
			await this.forms[this.currentKid].unlock();

			// Mise à jour de la ligne de la liste de résultats
			if (this.row && !this.forms[this.currentKid].parent) {
				await this.row.update({
					edit:          false,
					lock:          this.forms[this.currentKid].lock,
					name:          this.forms[this.currentKid].getName(),
					viewer_engine: this.forms[this.currentKid].viewer_engine,
				});
			}

			if (this.forms[this.currentKid]?.viewer_engine === 'html') {
				this.renderFileAsHTML(this.forms[this.currentKid].files[0].url);
			}

			this.#$scope.$broadcast('Form.submitted');
		}
		catch (error) {
			// In case of failure, stop the loading indicator
			console.error(error);
			this.$timeout(() => {
				this.loading = false;
			});
		}
	}

	trustAsHtml(string) {
		return this.#$sce.trustAsHtml(string);
	}

	/**
	 * Update the KID of a form
	 *
	 * @param {import('~/scripts/services/model/form').default} form
	 */
	updateKid(form) {
		const oldKid = this.currentKid;
		const newKid = form.kid;

		if (oldKid !== newKid) {
			Object.defineProperty(
				this.forms,
				newKid,
				Object.getOwnPropertyDescriptor(this.forms, oldKid),
			);
			delete this.forms[oldKid];

			this.currentKid = newKid;
			this.$timeout(() => {
				this.forms[this.currentKid].formScope.kformForm.$setDirty();
			});
		}
	}

	$onChanges(changes) {
		if (changes.currentKid && changes.currentKid.currentValue !== changes.currentKid.previousValue) {
			this.setName();
		}

		if (changes.kid) {
			this.loadGraph = false;
			let pass = false;
			if (
				changes.kid.currentValue
				&& changes.kid.currentValue !== changes.kid.previousValue
			) {
				pass = changes.kid.previousValue && this.currentKid in this.forms
					? this.forms[this.currentKid].reset() : true;
				if (pass) {
					this.#rootFormKid = null;
				}
			}

			// noinspection DuplicatedCode
			if (pass) {
				this.forms = {};
				(async () => {
					await this.addForm(this.create ? { isa: this.kid } : { kid: this.kid }, null);
					if (this.row) {
						await this.row.update({ edit: false });
					}
				})();
			}
		}

		if (changes.name) {
			this.#$rootScope.title = changes.name.currentValue ?? null;
		}

		if (changes.row?.currentValue && changes.row?.currentValue !== changes.row?.previousValue) {
			this.kid = this.row?.getData().kid;
			const newIsa = this.row?.getData().new_isa || null;

			this.loadGraph = false;
			let pass = true;
			if (changes.row.previousValue && this.forms && this.currentKid in this.forms) {
				pass = this.forms[this.currentKid].reset();
			}
			if (!pass && changes.row.previousValue) {
				this.$timeout(() => {
					changes.row.previousValue.deselect();
				});
			}
			else {
				this.#rootFormKid = null;
			}

			// noinspection DuplicatedCode
			if (pass) {
				this.forms = {};
				if (this.row) {
					(async () => this.row.update({ edit: false }))();
				}
				(async () => this.addForm(
					this.create ? { isa: this.kid } : { kid: this.kid },
					null,
					{ new_isa: newIsa },
				))();
			}
		}

		if (changes.tab && changes.tab?.currentValue !== changes.tab?.previousValue) {
			this.options.tab = changes.tab.currentValue;
			this.#$location.search('tab', this.options.tab)
				.replace();
			if (this.currentKid === this.#rootFormKid && this.forms[this.currentKid]) {
				this.forms[this.currentKid].tab = this.options.tab;
			}
		}
	}

	$onInit() {
		const scopeParent = this.#$scope.$parent;
		this.#formParent = scopeParent.form;

		kformUtils.init({
			kform: this,
		});

		this.#newKid = this.#$location.search().newKid;
		this.from = this.#$location.search().from;
		this.user = this.#$rootScope.context;

		this.options = {
			...this.defaultOptions,
			...this.options,
		};

		// Events ------------------------------------------
		this.#$scope.$on('Form.delete', (event, formKid) => {
			this.recursiveDeleteForm(formKid);
		});
		this.#$scope.$on('Form.nrReplace', (event, nr) => {
			if (this.currentKid in nr) {
				this.currentKid = nr[this.currentKid];
				this.kid = this.currentKid;
			}
			this.$timeout(() => {
				for (const [oldKid, newKid] of Object.entries(nr)) {
					if (this.forms && oldKid in this.forms) {
						delete Object.assign(this.forms, { [newKid]: this.forms[oldKid] })[oldKid];
						this.forms[newKid].kid = newKid;
					}
				}
			});
		});

		this.#$scope.$on('kexecScript', (_event, formKid, source) => {
			if (formKid && formKid in this.forms) {
				this.forms[formKid].kexecScriptWrapper(source)
			}
		});

		this.#$scope.$on('Form.refresh', () => this.refreshForm());

		this.#$scope.$on('Form.save', () => this.submit('save'));

		this.#$scope.$on('Form.set-new-isa', async (
			/** @type {Event} */ event,
			/** @type {?import('@knitiv/api-client-javascript').KNode} */ newIsa,
		) => {
			if (this.row) {
				this.options.new_isa = newIsa;
				this.forms[this.#rootFormKid].new_isa = newIsa;

				if (this.currentKid) {
					this.currentKid = this.#rootFormKid;
				}
				const form = this.forms[this.currentKid];
				const formKid = form.kid;

				this.loading = true;

				if (form.components) {
					form.components.length = 0;
				}
				else {
					form.components = [];
				}

				try {
					const result = await this.#FormService.load(
						form.kid,
						{
							create:  false,
							new_isa: newIsa,
							rg:      true,
						},
					);
					await this.loadForm(result, form.parent, {
						kid:  formKid,
						name: form.name,
					}, form.create, true);
					await this.edit();
				}
				catch (error) {
					this.loading = false;
					console.error(error);
				}
			}
		});

		this.#$scope.$on('updateComponent', (event, key, newComponent) => {
			if (this.currentKid in this.forms) {
				this.forms[this.currentKid].updateComponent(key, newComponent);
			}
		});

		this.#$scope.$on('Form.update', (event, form) => {
			if (this.forms && form.kid in this.forms && this.forms[form.kid]) {
				_.merge(this.forms[form.kid].components, form.components);

				if (this.forms[form.kid].formScope.kformForm) {
					for (const key of Object.keys(this.forms[form.kid].map)) {
						if (key in this.forms[form.kid].formScope.kformForm) {
							// Exception for radio buttons
							if (key in this.forms[form.kid].formScope.kformForm[key]) {
								this.forms[form.kid].formScope.kformForm[key][key].$validate();
							}
							else {
								this.forms[form.kid].formScope.kformForm[key].$validate();
							}
						}
					}
				}
			}
		});

		this.#$scope.$on('$destroy', () => {
			if (!this.options.parent) {
				this.#rootFormKid = null;
			}
		});

		this.connectedAgent = this.#Agent.connected;

		// this.user = this.#$rootScope.user; // TODO: is it necessary?

		// if (this.kid) {
		// 	this.addForm(this.create ? { isa: this.kid } : { kid: this.kid }, null);
		// }

		this.#$scope.$watch('$ctrl.forms[$ctrl.currentKid].submission.data', (data, oldData) => {
			if (
				data
				&& !this.loading
				&& oldData
			) {
				for (const [k, d] of Object.entries(data)) {
					const component = this.forms[this.currentKid].getComponent(k);
					if (component.hasChanged(d, oldData[k]) && !dataChanged.includes(k)) {
						dataChanged.push(k);
						if (component.type === 'datetime') {
							// remove kid for datetime component
							this.changeValue(k, oldData[k]);
						}
					}
				}

				if (this.currentKid in this.forms) {
					this.forms[this.currentKid].modified = dataChanged.length > 0;
				}
			}
		}, true);

		this.loading = true;
	}
}
